import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common"; 
import { CarouselModule } from "ngx-owl-carousel-o"; 
import { SharedModule } from "src/app/sharedModule/shared.module";  
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LandingPageComponent } from "./components/landing-page/landing-page.component";
import { TranslateModule } from "@ngx-translate/core";
import { RatingModule } from "ng-starrating"; 
import { HomeRoutingModule } from "./home-routing.module";

@NgModule({
  declarations: [ 
    LandingPageComponent, 
  ],
  imports: [
    CommonModule,
    CarouselModule,
    HomeRoutingModule,
    SharedModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,
    RatingModule, 
  ]
})
export class HomeModule {}
